import { render, staticRenderFns } from "./profile-menu.vue?vue&type=template&id=1438abe2&scoped=true"
import script from "./profile-menu.vue?vue&type=script&lang=js"
export * from "./profile-menu.vue?vue&type=script&lang=js"
import style0 from "./profile-menu.vue?vue&type=style&index=0&id=1438abe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438abe2",
  null
  
)

export default component.exports